import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  NgZone,
} from '@angular/core';

import { CommonModule, Location } from '@angular/common'; // Asegúrate de importar CommonModule
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService } from '../../../core/services/alert/alert.service';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { TabsFormComponent } from './tabs-form/tabs-form.component';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';

interface Model {
  reference: string;
  name: string;
}

interface FileItem {
  file: File;
  selectOption: string;
  key: string;
}
@Component({
  selector: 'app-form-add-order-pdf',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
    FormsModule,
    TabsFormComponent,
  ],
  templateUrl: './form-add-order-pdf.component.html',
  styleUrl: './form-add-order-pdf.component.css'
})
export class FormAddOrderPdfComponent implements OnChanges {

  @Output() backButtonClick = new EventEmitter<boolean>();
  @Output() addOrderPdf = new EventEmitter<any>();
  @Output() formSubmit = new EventEmitter<any>();

  @Input() orderData?: any; // Objeto opcional

  @Input() dataContainer?: any;

  @Input() document_buttons_chico = false;

  @Input() ladata: any = [];

  @Input() tab?: any;


  files: FileItem[] = [];

  isDragOver = false;

  showImportantDates = false;
  account_type: any = this.authStateService.getAccountType();
  form: FormGroup = this.fb.group({});
  draft = false;
  order_reference: string = '';
  /* client_reference: string = ''; */
  client: any = '';
  guarantee_reference: string = '';
  guarantee: any = '';
  back = '';
  brand_id_modal: any;
  searchParams: any = {};
  @Input() client_reference: any;
  //viene de la data
  selectTypes: any[] = [];

  newStage: string = '';
  title = '';
  activeForm = 'general';
  posiblesTabs: any[] = [
    'general',

  ];

  docFiles: any[] = [];

  stage?: any;
  rules: any = {};
  role: any;

  updatesTabs: any[] = [];

  helperStep = 1;
  //////////////////////////////////SI///////////////////////////////

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    private orderService: OrdersService,
    private location: Location,
    private localStorageService: LocalStorageService,
    private router: Router,
    private authStateService: AuthStateService,
    private ngZone: NgZone
  ) { }

  //////////////////////////////////NO///////////////////////////////

  ngOnChanges(changes: SimpleChanges) {
    this.refrescarFormulario();
    this.role = this.authStateService.getRole();
  }

  ngAfterViewInit() {
    this.form = this.fb.group({
      stage: ['draft', Validators.required],
    });
    this.refrescarFormulario();
  }


  setTitle() {
    this.title = this.orderData?.client?.name
      ? this.orderData?.client?.name +
      ' ' +
      (this.orderData?.client?.lastname
        ? this.orderData?.client?.lastname
        : '')
      : this.account_type === 'broker'
        ? this.orderData?.broker_reference
        : this.account_type === 'supplier'
          ? this.orderData?.supplier_reference
            ? this.orderData?.supplier_reference
            : this.orderData?.reference
          : this.orderData?.reference;
  }

  refrescarFormulario() {
    this.setTitle();
    if (this.posiblesTabs.includes(this.tab)) {
      if (this.activeForm != this.tab) {
        this.activeForm = this.tab;
      }
    }

    this.alertService.close();
  }

  goDocs() {
    this.activeForm = 'doc-order';
  }

  @Input() openedFromClients = false;
  @Output() closeOrderForm = new EventEmitter<void>();

  emitBackButtonClick() {
    const nuevaURL = this.location.path();
    const index = nuevaURL.indexOf('/');
    this.location.go(nuevaURL.substring(0, index));
    this.backButtonClick.emit(true);
  }



  refrescar() {
    this.alertService.loading('swal_messages.please_wait');
    this.orderService.getDataByReference(this.orderData.reference).subscribe({
      next: (data) => {
        this.orderData = data.data;
        this.refrescarFormulario();
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
          }
        });
      },
    });
  }

  /*
    onFileInputChange(event: Event): void {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];

      if (file) {
        this.handleFileUpload(file);
      }
    } */

  onFileInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const newFiles = input.files;
    if (newFiles && newFiles.length > 0) {
      this.handleFileUpload(newFiles);
    }
  }

  emitAddOrder(reference: any) {
    this.addOrderPdf.emit(reference);
  }

  /**
   * Valida un archivo PDF antes de subirlo
   * @param file Archivo a validar
   * @returns true si el archivo es válido, false en caso contrario
   */
  private validatePdfFile(file: File): { valid: boolean; error?: string } {
    // 1. Validar extensión del archivo
    const allowedExtensions = ['.pdf'];
    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
    
    if (!hasValidExtension) {
      return { valid: false, error: 'swal_messages.invalid_file_extension_pdf' };
    }

    // 2. Validar MIME type
    const allowedMimeTypes = ['application/pdf'];
    if (!allowedMimeTypes.includes(file.type)) {
      return { valid: false, error: 'swal_messages.invalid_file_type_pdf' };
    }

    // 3. Validar tamaño del archivo (máximo 10MB)
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSizeInBytes) {
      return { valid: false, error: 'swal_messages.file_too_large_10mb' };
    }

    // 4. Validar tamaño mínimo (evitar archivos vacíos)
    if (file.size === 0) {
      return { valid: false, error: 'swal_messages.file_is_empty' };
    }

    return { valid: true };
  }

  /**
   * Sanitiza el nombre del archivo para evitar inyecciones
   * @param fileName Nombre del archivo original
   * @returns Nombre sanitizado
   */
  private sanitizeFileName(fileName: string): string {
    // Eliminar caracteres peligrosos y mantener solo alfanuméricos, guiones, puntos y guiones bajos
    return fileName.replace(/[^a-zA-Z0-9._-]/g, '_');
  }

  handleFileUpload(files: FileList): void {
    if (files) {
      // Validar todos los archivos antes de subirlos
      const validFiles: File[] = [];
      const invalidFiles: string[] = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const validation = this.validatePdfFile(file);
        
        if (validation.valid) {
          validFiles.push(file);
        } else {
          invalidFiles.push(`${file.name}: ${validation.error}`);
        }
      }

      // Si hay archivos inválidos, mostrar error
      if (invalidFiles.length > 0) {
        this.alertService.error(
          invalidFiles.length === 1 
            ? invalidFiles[0] 
            : `swal_messages.multiple_invalid_files: ${invalidFiles.join(', ')}`
        );
        
        // Si no hay archivos válidos, detener el proceso
        if (validFiles.length === 0) {
          return;
        }
      }

      // Procesar solo los archivos válidos
      const formData = new FormData();
      for (let i = 0; i < validFiles.length; i++) {
        formData.append(`file[${i}]`, validFiles[i]);
      }

      this.alertService.loading('swal_messages.please_wait');

      this.orderService.uploadDocumentPdf(formData).subscribe({
        next: (response) => {
          this.alertService.close();
          // this.emitAddOrder(response.data.reference);
          this.alertService
            .successOk('swal_messages.pdfs_uploaded')
            .then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(['/orders/after-sales-factory']);
              }
            });

        },
        error: (error) => {
          console.error('Error al subir el documento:', error);
          this.alertService.error(error.error);
        },
      });
    }
  }


  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    const droppedFile = event.dataTransfer?.files;

    if (droppedFile) {
      this.handleFileUpload(droppedFile);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
  }

}
